<script>

    import { onMount } from "svelte";

	export let appdesc;
	export let connections;

	let language ='de';
    $: ID = (appdesc && appdesc.uri) ? appdesc.uri
        .replace(/http:/,'')
        .replace(/:/g,'')
        .replace(/\//g,'')
        .replace(/\./g,'')
        .replace(/\_/g,'') : '';

     onMount(async function() {
     });

     async function  fetchSource (sourceURL) {

         let response = await fetch(sourceURL);
         response = await response.text();

         return response;

      }

     async function openAsTextInWindow (url, wid, specs) {

         let sourcecode = await fetchSource (url);

         var myWindow = window.open('', wid , specs);
         myWindow.document.open();
         myWindow.document.write('<PLAINTEXT>'+sourcecode);

    }

    function openAppInWindow (appURI, variant, technology, language, hint) {

        let specs=undefined;


        if (hint==='mobile'){
            specs = 'left=20,top=20,width=500,height=800,toolbar=1,resizable=0';
        }

        if (!variant) variant = root;
        if (!technology) variant = semanticui;
        if (!language) language = 'de';

        var appURL = connections.mimesisUI_URL
            + "\?applicationURI="+appURI
            + "&variantURI="+appURI+'/variants%23'+variant
            + '&technology='+technology
            + '&language='+language;

        window.open ( appURL, ID+'_app', specs);

    }

    function openAppResourceInWindow (appURI, resource ) {

        var appURL = connections.mimesisResources_URL
        + '?resourceURL=' +appURI+ '/' + resource;
        window.open ( appURL, ID+'_'+resource, null);
        //openAsTextInWindow ( appURL, ID+'_'+resource, null);
    }

    function openAppOntologyInWindow (appURI ) {

        var appURL = connections.mimesisAppModelOntology_URL
            + '?applicationURI=' +appURI;
        window.open ( appURL, ID+'_apponto', null);
        //openAsTextInWindow (appURL, ID+'_apponto', null);
    }


</script>

<style>
.btn {
    margin : .2em;
    }


.card {
    padding:1em;
    height:100%;
    overflow: auto;
}

.card h3 {
    padding:0 0 1em 0;
    margin:0em;
}

</style>


{#if appdesc && appdesc.uri}

            <div class=" jumbotron card" >
                <div class="row text-center">

                        <h3>{@html appdesc.label} <br><small>{@html appdesc.subtitle}</small></h3>
                        <div class="col-4">
                            {#if appdesc.picture}<img  class="appimage" src="{appdesc.picture}" alt=""> {/if}
                        </div>
                        <span style="text-align:left;">
                            <div>
                                {@html appdesc.description}
                            </div>

                        </span>
                </div>
                <div class="row">
                    <div>
                        <b>Additional Inspection:</b> {appdesc.features.inspection}
                    <br/>
                        <b>Ontology for Collected Data </b>: {appdesc.features.ontology}
                    <br/>
                        <b>Commented Version: </b>{appdesc.features.commented}
                    </div>
                </div>

                <div class="row text-center">
                    <h4>Runnable Applicaiton Ressources:</h4>

                    {#if appdesc.languages && appdesc.languages.length>1}
                    <div class="row">
                        Select language: <select bind:value={language}>
                            {#each appdesc.languages as lng}
                                <option value={lng}>
                                    {lng}
                                </option>
                            {/each}
                        </select>
                     </div>
                    {/if}

                    <div class="row ">
                        {#each appdesc.variants as variant, i (variant)}
                             <a class="btn col-4 "
                                on:click={ () => openAppInWindow(appdesc.uri,variant.id,variant.technology,language)}
                                class:btn-danger={ (i === 0) }
                                class:btn-info={ (i > 0 ) } >
                                {variant.label}
                             </a>
                        {/each}
                    </div>
                </div>

                <div class="row text-center">
                    <h4>Static Applicaiton Ressources:</h4>
                    <div class="row">
                        <a class="btn btn-info col-4"
                           on:click={ () => openAppResourceInWindow(appdesc.uri,'')}
                           target="source" >Application Model</a>
                        <a class="btn btn-info col-4"
                           on:click={ () => openAppResourceInWindow(appdesc.uri,'variants')}
                           target="source" >Variant Description</a>
                        {#each appdesc.languages as lng}
                          <a class="btn btn-info col-4"
                             on:click={ () => openAppResourceInWindow(appdesc.uri,'assets/'+lng+'_app_labels.properties')}
                             target="source" >Asset - labels ({lng}) </a>
                        {/each}
                        <a class="btn btn-info col-4"
                            on:click={ () => openAppResourceInWindow(appdesc.uri,'uiresources/scripts.js')}
                            target="source" >Code (JavaScript)</a>
                        <a class="btn btn-info col-4"
                            on:click={ () => openAppResourceInWindow(appdesc.uri)}
                            target="source" >Ontological Application Model</a>

                    </div>
                </div>

            </div>

{:else if appdesc}
     <div class="jumbotron card" >
         <div class="row text-center">
             <h3>{@html appdesc.label} </h3>
         </div>
          <div class="row">
             {@html appdesc.description}
          </div>
     </div>
{:else}

<div>
    Please Select Application
</div>

{/if }